import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';
import PageContent from '../../../../shared/components/PageContent';
import PageHeader from '../../../../shared/components/PageHeader';
import Page from '../../../../shared/components/Page';
import SearchForm from '../../../../shared/containers/forms/SearchForm';

import { getManyCollections } from '../../../../shared/actions/index';
import CompanyAdminCollectionTable from './ViewAllCompanyAdminCollections';
import { RuntimeContext } from '../../../../../common/RuntimeContext';

const getSearchFilter = (companyName) =>
    `(subscriptionType:AvailableForAll OR companies:"${companyName}") AND isActive:true`;

class ViewAllCollectionsContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            exclusiveCollections: []
        };
    }

    static propTypes = {
        getManyCollections: PropTypes.func.isRequired,
        history: PropTypes.object.isRequired,
        userCompany: PropTypes.object,
        match: PropTypes.shape({
            params: PropTypes.shape({
                section: PropTypes.string
            })
        }),
        loggedInUser: PropTypes.object
    };

    static contextType = RuntimeContext

    componentDidMount() {
        return this.props.getManyCollections({pathsContext: this.context.pathsWeb}).then((collections) => {
            this.setState({ exclusiveCollections: collections });
        });
    }

    _handleResults = (results) => {
        this.setState({ exclusiveCollections: results });
    };

    render() {
        const { history, userCompany } = this.props;
        const { exclusiveCollections } = this.state;
        return (
            <Page className={'manage-collections'}>
                <PageHeader title={'Collections'} className={'adminTableHeaderTabs adminPageHeader'} />
                <PageContent className={'manageTrackV2Wrapper adminWrapper mt-5'}>
                    <div className={'row'}>
                        <div className={'col-4 ms-auto'}>
                            <SearchForm
                                indexName={'Collections'}
                                handleSearchResults={this._handleResults}
                                onSubmit={this._handleSearchSubmit}
                                placeholderTextId={'MANAGE_SEARCH'}
                                placeholderDefault={'Search'}
                                attributesToRetrieve={['_id', 'name', 'thumbnailImageUrl', 'updatedOn']}
                                defaultFilters={getSearchFilter(userCompany.name)}
                                retrieveFullResults={true}
                                pathsContext={this.context.pathsWeb}
                            />
                        </div>
                    </div>
                    <CompanyAdminCollectionTable allCollections={exclusiveCollections} history={history} />
                </PageContent>
            </Page>
        );
    }
}

export const ManageCollectionsComponent = ViewAllCollectionsContainer;

const makeMapStateToProps = () => {
    const mapStateToProps = (state) => {
        const {
            auth: { isContentAuthor, isVerbAdmin, loggedInUserCompanyId, loggedInUser },
            companies
        } = state;

        return {
            loggedInUserCompanyId,
            userCompany: companies.byId[loggedInUserCompanyId] || {},
            isContentAuthor,
            isVerbAdmin,
            loggedInUser
        };
    };

    return mapStateToProps;
};

const mapDispatchToProps = (dispatch) => ({
    getManyCollections: (params) => dispatch(getManyCollections(params))
});

export default withRouter(connect(makeMapStateToProps, mapDispatchToProps)(ViewAllCollectionsContainer));
